/**
 * pages.config.js - Page routing configuration
 *
 * THE ONLY EDITABLE VALUE (historically): mainPage
 *
 * Pages other than the landing page are code-split with React.lazy so the
 * initial JavaScript bundle only contains what the Home page actually needs.
 * Heavy screens (AdminSettings pulls in chart libraries and every admin panel,
 * Checkout pulls in the payment flow) are then fetched on first visit instead
 * of being downloaded by every visitor up front.
 *
 * Home stays eagerly imported — it's the landing page, so lazy-loading it would
 * only add a round trip before first paint.
 *
 * App.jsx wraps its <Routes> in a <Suspense> boundary, which is what renders
 * while a lazy page's chunk is downloading.
 */
import lazy from '@/lib/lazyRetry';
import Home from './pages/Home';
import __Layout from './Layout.jsx';

const Account = lazy(() => import('./pages/Account'));
const AdminSettings = lazy(() => import('./pages/AdminSettings'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Loyalty = lazy(() => import('./pages/Loyalty'));
const Order = lazy(() => import('./pages/Order'));
const Orders = lazy(() => import('./pages/Orders'));
const Profile = lazy(() => import('./pages/Profile'));


export const PAGES = {
    "Account": Account,
    "AdminSettings": AdminSettings,
    "Checkout": Checkout,
    "Home": Home,
    "Loyalty": Loyalty,
    "Order": Order,
    "Orders": Orders,
    "Profile": Profile,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};